Vue.component('MpBusinessHighlights', {
    props: {
        businessType: String,
        source: String,
        detailPath: String,
        businessPage: Number,
        title: String,
        itemsPerPage: Number,
        itemList: Array,
    },
    data: function() {
        return {
            businessList: [],
        };
    },
    watch: {
        itemList: function(newList, oldList) {
            this.businessList = newList;
        },
    },
    computed: {
        businessHighlights: function() {
            if (this.itemsPerPage) {
                return this.businessList.slice(0, this.itemsPerPage);
            } else {
                return this.businessList;
            }
        }
    },
    methods: {

        getDetailUrl: function(businessReference) {
            return this.detailPath + businessReference + '/type/' + this.businessType + '/owner/registered';
        },

        onSourceDataLoad: function(response) {
            if (response.status !== 200) {
                return;
            }

            this.businessList = response.data.highlights;
        },

        loadHighlights: function() {
            axios
                .post(this.source + this.businessType + '/page/' + this.businessPage)
                .then(this.onSourceDataLoad)
                .catch(function(error) {
                    console.log(error);
                });
        },

        init: function() {
            if (this.itemList.length) {
                this.businessList = this.itemList;
            } else {
                this.loadHighlights();
            }
        }
    },

    mounted: function() {
        this.init();
    },

    updated: function() {},

    template: '\
    <section class="business-highlights highlighted-cta promo promo--fullwidth">\
        <header class="highlighted-cta__header">\
            <h2 class="highlighted-cta__title">{{title}}</h2>\
        </header>\
\
        <ul class="business-highlights__list">\
            <li class="business-highlights__item" v-for="business in businessHighlights">\
                <a class="business-highlights__item-link" :href="getDetailUrl(business.id)">\
                    <div class="row row--compact">\
                        <div class="col-auto">\
                            <div class="business-highlights__item-icon icon">\
                                <svg class="icon__inner" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 5H9c-.429 0-1 .545-1 .973v5.038c0 .429.571.988 1 .989h5c.429 0 1-.56 1-.989V5.973C15 5.545 14.429 5 14 5zm-.5 5.5h-4l.04-4h3.96v4zM20.422 11.414a1.922 1.922 0 100-3.844 1.907 1.907 0 00-.824.193V5.549a.549.549 0 10-1.098 0v3.943a1.925 1.925 0 001.922 1.922zm0-2.746a.825.825 0 110 1.649.825.825 0 010-1.65z" fill="currentColor"/><path d="M22.124 20.5H17.73V3.089c0-.6-.488-1.088-1.09-1.089H6.737c-.602 0-1.236.488-1.237 1.089V20.5h-.95c-.304 0-.55.447-.55.75s.246.75.55.75h17.574c.303 0 .549-.447.549-.75s-.246-.75-.55-.75zM7 3.5h9v17H7v-17z" fill="currentColor"/></svg>\
                            </div>\
                        </div>\
                        <div class="col">\
                            <h3 class="business-highlights__item-title">{{business.name}}</h3>\
                            <address class="business-highlights__item-address">\
                                <p class="business-highlights__item-text">{{business.address}}, {{business.zipCode}} - {{business.location}}</p>\
                                <p class="business-highlights__item-text">{{business.province}}</p>\
                            </address>\
                        </div>\
                        <div class="col-auto align-self-center u-lh-0">\
                            <div class="business-highlights__item-arrow icon icon--sm">\
                                <svg class="icon__inner" width="12" height="17" viewBox="0 0 12 17" xmlns="http://www.w3.org/2000/svg"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1059 -519)" stroke="currentColor" stroke-width="3"><g transform="translate(754 344)"><g transform="translate(0 119)"><path d="M307 58l7 6.5-7 7.5"/></g></g></g></g></svg>\
                            </div>\
                        </div>\
                    </div>\
                </a>\
            </li>\
        </ul>\
    </section>',
});
